import React from "react";
import { Box } from "@chakra-ui/react";

const Number = ({ value }) => {
  return (
    <Box
      display={{ base: "inline", md: "block" }}
      w={{ base: "auto", md: "100%" }}
      textAlign={"right"}
    >
      {value}
    </Box>
  );
};

export default Number;
